// This component is not needed anymore since we're using Cookiebot's UI
export default function CookieConsent() {
  return null;
}